const notImplemented = () => { throw new Error('Not implemented'); };

export default notImplemented;
